import { defineMessages } from 'react-intl'

const scope =
  'platform.banking.features.downloadFinancialAccountStatement.presenters.downloadFinancialAccountStatementPresenter'

export default defineMessages({
  downloadButtonText: {
    id: `${scope}.downloadButtonText`,
    defaultMessage: 'Download',
  },
  successToastTitle: {
    id: `${scope}.successToastTitle`,
    defaultMessage: 'Statement downloading',
  },
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'Download failed',
  },
})
